import { useModalLayout } from 'components/BatchCreateCampaignsModal/ModalLayoutProvider/ModalLayoutProvider'
import { Portal } from 'components/Portal/Portal'
import { PropsWithChildren } from 'react'

export const ModalTitleContainer = ({ children }: PropsWithChildren) => {
  const { titleContainer } = useModalLayout()

  return <Portal container={titleContainer}>{children}</Portal>
}
